import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchWorkFlow = createAsyncThunk(
  'workFlow/fetchWorkFlow',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkFlow({
        workFLowFor: params?.workFLowFor,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.workFlowDefinitionID,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.workFlowDefinitionID,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const fetchWorkFlow_RemoteWork = createAsyncThunk(
  'workFlow/fetchWorkFlow_RemoteWork',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkFlow({
        workFLowFor: params?.workFLowFor,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.workFlowDefinitionID,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.workFlowDefinitionID,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchWorkFlow_Leave = createAsyncThunk(
  'workFlow/fetchWorkFlow_Leave',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkFlow({
        workFLowFor: params?.workFLowFor,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.workFlowDefinitionID,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.workFlowDefinitionID,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchWorkFlow_ManualEntry = createAsyncThunk(
  'workFlow/fetchWorkFlow_ManualEntry',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkFlow({
        workFLowFor: params?.workFLowFor,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.workFlowDefinitionID,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.workFlowDefinitionID,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchWorkFlow_Permission = createAsyncThunk(
  'workFlow/fetchWorkFlow_Permission',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkFlow({
        workFLowFor: params?.workFLowFor,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.workFlowDefinitionID,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.workFlowDefinitionID,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  workFlowList: [],
  workFlowLeaveList: [],
  workFlowPermissionList: [],
  workFlowManualEntryList: [],
  workFlowRemoteWorkList: [],
  loading: false,
  error: '',
};

const workFlowSlice = createSlice({
  name: 'workFlow',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkFlow.fulfilled, (state, action) => {
        state.loading = false;
        state.workFlowList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkFlow.rejected, (state, action) => {
        state.loading = false;
        state.workFlowList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(fetchWorkFlow_Leave.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkFlow_Leave.fulfilled, (state, action) => {
        state.loading = false;
        state.workFlowLeaveList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkFlow_Leave.rejected, (state, action) => {
        state.loading = false;
        state.workFlowLeaveList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(fetchWorkFlow_Permission.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkFlow_Permission.fulfilled, (state, action) => {
        state.loading = false;
        state.workFlowPermissionList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkFlow_Permission.rejected, (state, action) => {
        state.loading = false;
        state.workFlowPermissionList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(fetchWorkFlow_RemoteWork.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkFlow_RemoteWork.fulfilled, (state, action) => {
        state.loading = false;
        state.workFlowRemoteWorkList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkFlow_RemoteWork.rejected, (state, action) => {
        state.loading = false;
        state.workFlowRemoteWorkList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(fetchWorkFlow_ManualEntry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkFlow_ManualEntry.fulfilled, (state, action) => {
        state.loading = false;
        state.workFlowManualEntryList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkFlow_ManualEntry.rejected, (state, action) => {
        state.loading = false;
        state.workFlowManualEntryList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default workFlowSlice.reducer;
